import { ReactElement } from "react";
import dayjs from "dayjs";
import { useBreakpointValue } from "@chakra-ui/react";
import { ResultChartData, CustomDotType } from "../../../types";
import { XAxisProps } from "recharts";
import { useColorToken } from "../../../hooks/useColorToken";
interface CustomXAxisTickProps extends XAxisProps {
  payload?: {
    value: number;
  };
}

export function getTicks(now: number, dayCount: number): number[] {
  const millisecPerDay = 86400000;
  const ticks: number[] = [];
  for (let i = dayCount; i > 0; i--) {
    ticks.push(now - millisecPerDay * i);
  }

  ticks.push(now);
  ticks.push(now + millisecPerDay + 1); // 最後の値だけ表示を隠すためのトリック
  return ticks;
}

/**
 * rechartsのxaxisで本日だけ太文字するするカスタムtick
 */
export const CustomXAxisTick = (props: CustomXAxisTickProps): ReactElement => {
  const textColor = useColorToken("common_text.gray");
  const fontSize = useBreakpointValue({ base: 10, md: 12 });

  const fillOpacity =
    props.payload?.value && props.payload.value % 1000 == 1 ? 0 : 1;

  return (
    <g transform={`translate(${props.x},${props.y})`}>
      <text
        x={4}
        y={0}
        dy={16}
        fontSize={fontSize}
        fontWeight={300}
        fontFamily="Oswald"
        textAnchor="end"
        fill={textColor}
        fillOpacity={fillOpacity}
      >
        {props?.payload?.value ? dayjs(props.payload.value).format("D") : null}
      </text>
    </g>
  );
};

export const CustomDot = (props: CustomDotType): ReactElement => {
  const cx = props.cx;
  const cy = props.cy;
  const isMi1ResultUnReliability =
    props.payload?.mi1_result_reliability === false;
  const isMentalActivityReliability =
    props.payload?.mental_activity_reliability === false;
  const mi1resultColor = useColorToken("mi1Result.primary");
  const commonBase = useColorToken("common.base");

  if (cx == null || cy == null || props.value == null) {
    return <></>;
  }

  let figure = "circle";
  let dotColor = props.dotColor;
  let fillColor = props.dotColor;

  if (props.dataKey === "mi1_result" && isMi1ResultUnReliability) {
    fillColor = commonBase;
  } else if (
    props.dataKey === "mi1_result" &&
    props.thresholdAlertValue &&
    Number(props.value) < props.thresholdAlertValue
  ) {
    dotColor = mi1resultColor;
    figure = "square";
  } else if (
    props.dataKey === "mental_activity100" &&
    isMentalActivityReliability
  ) {
    fillColor = commonBase;
  }

  if (figure === "square") {
    const x = cx ? cx - 2.5 : cx;
    const y = cy ? cy - 2.5 : cy;
    return (
      <svg>
        <rect
          x={x}
          y={y}
          height={5}
          width={5}
          stroke={dotColor}
          fill={fillColor}
          strokeWidth={props.strokeWidth}
        />
      </svg>
    );
  } else {
    return (
      <svg>
        <circle
          cx={cx}
          cy={cy}
          r={props.r}
          stroke={dotColor}
          fill={fillColor}
          strokeWidth={props.strokeWidth}
        />
      </svg>
    );
  }
};

export function averageLabelPosition(
  data: ResultChartData[],
  referenceLineY: number,
  key: string,
): "insideBottomLeft" | "insideTopLeft" {
  const detectPositionNumber = data.slice(0, 3).reduce((acc, singleData) => {
    if (!(key in singleData)) return acc - 1;
    return singleData[key] < referenceLineY ? acc - 1 : acc + 1;
  }, 0);
  return detectPositionNumber < 0 ? "insideBottomLeft" : "insideTopLeft";
}
